<template>
  <div>
    <div class="wizard__header" v-html="this.header"></div>
      <form class="wizard__form wizard__form--smaller" ref="form" @submit.prevent="nextClickHandler">
        <div class="row">
          <div class="small-12 medium-6 large-6 columns">
            <div class="wizard__input-group input-group input-group--material input-group--select input-group--required">
              <input class="input-group__textinput" type="text" name="scheduledMoveDate" ref="scheduledMoveDate" required v-dirty />
              <label class="input-group__label" for="scheduledMoveDate">Date</label>
            </div>
          </div>
          <div class="small-12 medium-6 large-6 columns">
            <div class="wizard__input-group input-group input-group--select">
              <select class="input-group__textinput input-group__textinput--select" name="scheduledMoveTime" required>
                <option value="" selected="" disabled>Arrival Window</option>
                <option value="8:00 AM">8:00 AM - 9:00 AM</option>
                <option value="9:00 AM">9:00 AM - 10:00 AM</option>
                <option value="10:00 AM">10:00 AM - 11:00 AM</option>
                <option value="11:00 AM">11:00 AM - 12:00 PM</option>
                <option value="12:00 PM">12:00 PM - 1:00 PM</option>
                <option value="1:00 PM">1:00 PM - 2:00 PM</option>
                <option value="2:00 PM">2:00 PM - 3:00 PM</option>
                <option value="3:00 PM">3:00 PM - 4:00 PM</option>
              </select>
            </div>
          </div>
        </div>
      </form>

      <ul class="wizard__nav" v-if="onPrevious">
        <li class="wizard__nav__item"><a class="wizard__nav__link wizard__nav__link--previous" @click.prevent="onPrevious">Previous</a></li>
        <li class="wizard__nav__item"><a class="wizard__nav__link wizard__nav__link--next" @click.prevent="nextClickHandler">Review Details</a></li>
      </ul>
  </div>
</template>

<script>
  import $ from 'jquery';
  import flatpickr from 'flatpickr';
  import parsley from 'parsleyjs';
  import { serialize } from 'dom-form-serializer';
  import Popper from 'popper.js';
  import Tooltip from 'tooltip.js';

  export default {
    props: {
      onResponse: {
        type: Function
      },

      onPrevious: {
        type: Function
      },

      header: {
        type: String
      }
    },

    data: () => ({
      name: 'scheduleMove',
      flatpickrInstance: null
    }),

    computed: {

    },

    mounted() {
      this.createFlatpickr();
      this.createPopper();
    },

    methods: {
      createFlatpickr() {
        this.flatpickrInstance = flatpickr(this.$refs.scheduledMoveDate, {
          minDate: new Date().fp_incr(2),
          dateFormat: 'F d, Y',
          disable: [
            date => date.getDay() === 0
          ],
          disableMobile: 'true'
        });

        // flatpickr(this.$refs.scheduledMoveTime, {
        //   enableTime: true,
        //   noCalendar: true,
        //   dateFormat: 'h:i K',
        //   altFormat: '…',
        //   altInput: true,
        //   minDate: '8:00',
        //   maxDate: '15:00',
        //   minuteIncrement: 60,
        //   disableMobile: 'true',
        //   onChange: (selectedDates, dateStr, instance) => {
        //     let $altInput = instance.altInput;
        //     let nextHour = (selectedDates[0].getHours() % 12) + 1;
        //     let dateStr2 = dateStr.replace(/.+:/, `${nextHour}:`);

        //     $altInput.value = `${dateStr} - ${dateStr2}`;;
        //   }
        // });
      },

      createPopper() {
        let $disabledDays = (this.flatpickrInstance.rContainer).querySelectorAll('.flatpickr-day.disabled');

        [...$disabledDays].forEach($disabledDay => {
          new Tooltip($disabledDay, {
            placement: 'top',
            title: 'Your date not available? Give us a call to see if we have any last minute availability'
          });
        });
      },

      nextClickHandler() {
        if (! $(this.$refs.form).parsley().validate())
          return;

        let $form = this.$refs.form;
        let data = serialize($form);

        if (! this.onResponse) return;

        this.onResponse({
          data,
          response: true
        });
      }
    }
  };
</script>
